import React from "react";

const GalleryHeader = () => {
  return (
    <section className="header">
      <div className="header__overlay"></div>
      <div className="header__wrapper">
         <div className="header__text">
           <h3>Explore o mundo através de uma lente</h3> 
         </div>
      </div>
    </section>
  );
};

export default GalleryHeader;
